import React from "react";
import { Form } from "react-bootstrap";
import styles from "./signInput.module.css";

const SignInInput = ({
  label,
  type,
  placeholder,
  value,
  onCopy,
  onPaste,
  containerClasses,
  name,
  onChange,
  errorMessage,
  isInvalid,
  onBlur,
  showcodediv = false,
  disabled = false,
  icon,
  codedivName = "",
  countryCode,
  onKeyPress
}) => {
  
  return (
    <Form.Group className={`${containerClasses}`} controlId="formBasicEmail" >
      {label ? <Form.Label className={styles.label}>{label}</Form.Label> : ""}
      <div
        className={showcodediv ? styles.outerdivcontainer : null}
        style={!showcodediv ? { position: "relative" } : null}
      >
        {showcodediv ? (
          <>
            {codedivName === "phone" ? (
              <div className={styles.addphonecode}>+91</div>
            ) : codedivName === "countryMapping" ? (
              <div className={styles.addphonecode}>{countryCode}</div>
            ) : ""}
          </>
        ) : (
          ""
        )}
        <img src={icon} alt="" className={styles.icon}></img>
        <Form.Control
          type={type}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          className={ showcodediv === true ? `${styles.iconinputContainer} ${styles.inputContainer}` : styles.inputContainer}
          value={value}
          onPaste={onPaste}
          onCopy={onCopy}
          isInvalid={isInvalid}
          onBlur={onBlur}
          disabled={disabled}
          style={icon ? { paddingLeft: "36px",
         } : { width: "100%" }}
         onKeyPress={onKeyPress}
        />
      </div>
      <Form.Control.Feedback type="invalid" className={styles.errorState}>
        {errorMessage}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default SignInInput;
